import React from "react";
import classnames from "classnames";

import styles from "../FormField.module.scss";

export interface IGeoFormFieldProps {
  id?: string;
  error?: string;
  name?: string;
  currentValue?: string | number;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const GeoFormField: React.FC<IGeoFormFieldProps> = ({
  registerField,
  error,
  isFocused,
  ...props
}) => {
  return (
    <input
      {...registerField}
      className={classnames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      {...props}
      type="text"
    />
  );
};
